import { Backend } from '@/_axios';

export default {
  LOAD_GET_USERS_LAST_PLANNED_LOGS: function ({ commit }) {
    Backend.get('/api/users_last_planned_logs').then((response) => {
      // commit('SET_USERS', response.data)
      commit('SET_LAST_PLANNED_LOGS', response.data);
    }, (err) => {
      console.log(err);
    });
  },
};
